import { api } from "@/lib/axios";
import { User } from "@/types/user";

const deleteOne = (id: string): Promise<User> =>
  api.delete(`/users/${id}`).catch(() => null) as unknown as Promise<User>;

export default deleteOne;
